import { createFileRoute, redirect } from "@tanstack/react-router";
import { Shop } from "../components/shop/shop";
import { useAuthStore } from "../data/useAuthStore";

export const Route = createFileRoute("/shop")({
  component: RouteComponent,
  loader() {
    const activeClubId = useAuthStore.getState().activeClubId;

    if (!activeClubId) {
      return redirect({
        to: "/home",
      });
    }
  },
});

function RouteComponent() {
  return <Shop />;
}
